import { db } from '@/core/db/dexie'

/**
 * Cache offline do carreteiro (tabela `cache_carreteiro`). Guarda as últimas
 * respostas que dependem de obra/caminhão/data, para o operador conseguir
 * lançar sem sinal. Tudo é revalidado pelo servidor no envio.
 *
 * Chaves: `chefe:<obraId>`, `mves:<obraId>`, `servicos:<mveId>`.
 */
export async function lerCache<T>(key: string): Promise<T | null> {
  try {
    const row = await db.cache_carreteiro.get(key)
    return row ? (row.value as T) : null
  } catch {
    return null
  }
}

export async function gravarCache(key: string, value: unknown): Promise<void> {
  try {
    await db.cache_carreteiro.put({ key, value, fetchedAt: Date.now() })
  } catch (e) {
    console.warn('[carreteiroCache] falha ao gravar', key, e)
  }
}
